(function () {
  'use strict';

  angular.module('MktzapApp.Factories')
    .factory('WebhookService', WebhookService);

  WebhookService.$inject = ['$resource'];

  function WebhookService ($resource) {
    return $resource(apiUrl + '/webhook', {}, {
      all: { method: 'GET', isArray: true },
      save: { method: 'POST', params: {}, isArray: false },
      update: { method: 'PATCH', params: {}, isArray: false },
      delete: { method: 'DELETE', params: {}, isArray: false }
    });
  }
})();
